import { Job } from '@/types/schema';
import { ApiService } from './api.service';
import { GARMENT_COMBINATION_REQUEST_TIMEOUT_MS } from '@/lib/constants/poll';
import { CreateGarmentCombinationJobRequest } from '@/types/garment-combination';

export class JobService {
  static async getJob(jobId: string): Promise<Job> {
    const response = await ApiService.get<{ job: Job }>(`/jobs/${jobId}`);
    return response.job;
  }

  static async getFaceswapRecognitionJob(projectFolderId: string): Promise<Job | null> {
    try {
      const response = await ApiService.get<{ job: Job }>(
        `/jobs/faceswap-recognition/${projectFolderId}`,
      );
      return response.job;
    } catch (error) {
      if (error instanceof Error && error.message === 'Faceswap recognition job not found') {
        return null;
      }
      throw error;
    }
  }

  static async createGarmentCombinationJob(
    body: CreateGarmentCombinationJobRequest,
  ): Promise<{ jobId: string }> {
    return ApiService.post<{ jobId: string }>('/jobs/garment-combination', body, {
      timeout: GARMENT_COMBINATION_REQUEST_TIMEOUT_MS,
    });
  }
}
